import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  facilityId: null,
};

export const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setFacilityId: (state, action) => {
      const parsedPayload = parseInt(action.payload);
      state.facilityId = isNaN(parsedPayload) ? action.payload : parsedPayload;
    },
  },
});

export const { setFacilityId } = AuthSlice.actions;

export const selectFacilityId = (state) => state?.auth?.facilityId;

export default AuthSlice.reducer;
